import { useNavigate } from "react-router-dom";
import { PhoneCall, Lock } from "lucide-react";

const MASKED = "(•••) •••-••••";

// Shows the paid line as inert text when revealed, or a masked placeholder with a
// hint pointing to the step that unlocks it (verify phone, then add credits).
export const PaidLineNumber = ({ paidLine, size = "lg", testIdPrefix = "callin" }) => {
  const navigate = useNavigate();
  const cls =
    size === "lg"
      ? "font-heading font-black text-2xl tracking-tighter inline-flex items-center gap-2"
      : "font-mono font-bold inline-flex items-center gap-2";

  if (paidLine.number) {
    return (
      <span data-testid={`${testIdPrefix}-phone-number`} className={`${cls} text-white select-text`}>
        {size === "lg" && <PhoneCall className="w-5 h-5 text-[#007AFF]" />}
        {paidLine.number}
      </span>
    );
  }

  const needsCredits = paidLine.verified && !paidLine.has_credits;
  const hint = needsCredits ? "Add credits to reveal" : "Verify phone to reveal";
  const target = needsCredits ? "/credits" : "/profile";

  return (
    <button onClick={() => navigate(target)} data-testid={`${testIdPrefix}-phone-locked`}
      className={`${cls} text-left text-muted-foreground hover:text-white transition-colors duration-200`}
      title={needsCredits ? "Add credits to reveal the call-in line" : "Verify your phone number to reveal the call-in line"}>
      {size === "lg" && <Lock className="w-4 h-4 text-amber-500" />}
      <span>{MASKED}</span>
      <span data-testid={`${testIdPrefix}-phone-hint`} className="text-xs font-sans font-semibold text-amber-500">{hint}</span>
    </button>
  );
};
